import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { getAdditionalInfoDisplay } from './utils';
import enums from '../../../../../constants/enums';
import './stylesheets/communicationAdditionalInfo.scss';
var CommunicationAdditionalInfo = function CommunicationAdditionalInfo(_ref) {
  var communicationTypes = _ref.communicationTypes,
    isPrimary = _ref.isPrimary;
  var contactCommunicationTypesEnums = get(enums, 'contact_data.communication_types');
  return /*#__PURE__*/React.createElement("div", {
    className: "communication-additional-info"
  }, getAdditionalInfoDisplay({
    communicationTypes: communicationTypes,
    enums: contactCommunicationTypesEnums,
    isPrimary: isPrimary
  }));
};
CommunicationAdditionalInfo.propTypes = {
  communicationTypes: PropTypes.array,
  isPrimary: PropTypes.bool
};
CommunicationAdditionalInfo.defaultProps = {
  communicationTypes: [],
  isPrimary: false
};
export default CommunicationAdditionalInfo;
//# sourceMappingURL=index.js.map